import PageLayout from "../components/common/page-layout";
import QueuesDashboard from "../components/queues-dashboard/queues-dashboard";
import { RequireAuth } from "../hooks/use-auth";

/** Route page for the background job queue dashboard. */
const QueuesPage = () => (
  <RequireAuth>
    <PageLayout maxWidth={false} title="Queues">
      <QueuesDashboard />
    </PageLayout>
  </RequireAuth>
);

export default QueuesPage;
